import React from 'react';

const StoryAndCTA = () => {
  return (
   
<>
            <section className="py-16 bg-white-50">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to transform your coaching business?</h2>
            <p className="text-lg text-gray-700 mb-8">Join the growing community of coaches who are saving time, increasing client retention, and growing their businesses with our AI-powered platform.</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="https://calendly.com/kolanut" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto bg-black text-white px-8 py-4 rounded-xl hover:bg-emerald-600 transition duration-300 font-medium flex items-center justify-center"
              >
                Schedule Demo
              </a>
              <a 
                href="#features"
                className="w-full sm:w-auto bg-white text-gray-900 border border-gray-200 px-8 py-4 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
              >
                Learn More
              </a>
            </div>
          </div>
        </section>

                <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-6">
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">Targeted to Solopreneurs</h3>
                <p className="text-gray-600">Built exclusively for coaching and wellness professionals with industry-specific templates and workflows.</p>
              </div>
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">True AI Differentiation</h3>
                <p className="text-gray-600">Not just automations—our platform learns user behavior and client preferences for personalized recommendations.</p>
              </div>
              <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
                <h3 className="text-xl font-semibold mb-3">Frictionless Experience</h3>
                <p className="text-gray-600">Minimal setup with calendar, payment, and email integrations for instant improvement in efficiency.</p>
              </div>
            </div>
          </div>
        </section>
        </>
  );
};

export default StoryAndCTA;